import { useState } from "react";
import { useAfterLargestContentfulPaint } from "@/lib/afterLargestContentfulPaint";
import { useSignedOut } from "@/lib/signedOutStore";
import { GTM_NEW_GITHUB_SIGNUP_QUERY } from "@/lib/githubAuthGtm";

/**
 * Whether the GTM and gtag loaders may run. The sign-in card and a
 * first-signup landing skip the LCP wait: visitors usually leave them within
 * seconds (GitHub OAuth, GitHub App install), and that full-page navigation
 * drops whatever is still queued in `dataLayer`.
 */
export function useTagLoaderReady() {
  const afterLcp = useAfterLargestContentfulPaint();
  const signedOut = useSignedOut();
  const [firstSignupLanding] = useState(_temp);
  return afterLcp || firstSignupLanding || signedOut;
}
function _temp() {
  return typeof window !== "undefined" && new URLSearchParams(window.location.search).get(GTM_NEW_GITHUB_SIGNUP_QUERY) === "1";
}